import { css } from 'react-emotion';

export const mdFormClasses = css`
   {
    position: relative;
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  & input[type='text'],
  & input[type='password'],
  & input[type='email'],
  & input[type='url'],
  & input[type='time'],
  & input[type='date'],
  & input[type='datetime-local'],
  & input[type='tel'],
  & input[type='number'],
  & input[type='search-md'],
  & input[type='search'],
  & textarea.md-textarea {
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    outline: none;
    box-shadow: none;
    border: none;
    border-bottom: 1px solid #ced4da;
    border-radius: 0;
    box-sizing: content-box;
    background-color: transparent;
  }
  & input[type='text']:focus:not([readonly]),
  & input[type='password']:focus:not([readonly]),
  & input[type='email']:focus:not([readonly]),
  & input[type='url']:focus:not([readonly]),
  & input[type='time']:focus:not([readonly]),
  & input[type='date']:focus:not([readonly]),
  & input[type='datetime-local']:focus:not([readonly]),
  & input[type='tel']:focus:not([readonly]),
  & input[type='number']:focus:not([readonly]),
  & input[type='search-md']:focus:not([readonly]),
  & input[type='search']:focus:not([readonly]),
  & textarea.md-textarea:focus:not([readonly]) {
    box-shadow: 0 1px 0 0 #4285f4;
    border-bottom: 1px solid #4285f4;
  }
  & input[type='text']:focus:not([readonly]) + label,
  & input[type='password']:focus:not([readonly]) + label,
  & input[type='email']:focus:not([readonly]) + label,
  & input[type='url']:focus:not([readonly]) + label,
  & input[type='time']:focus:not([readonly]) + label,
  & input[type='date']:focus:not([readonly]) + label,
  & input[type='datetime-local']:focus:not([readonly]) + label,
  & input[type='tel']:focus:not([readonly]) + label,
  & input[type='number']:focus:not([readonly]) + label,
  & input[type='search-md']:focus:not([readonly]) + label,
  & input[type='search']:focus:not([readonly]) + label,
  & textarea.md-textarea:focus:not([readonly]) + label {
    color: #4285f4;
  }
  & input[type='text'] + label:after,
  & input[type='password'] + label:after,
  & input[type='email'] + label:after,
  & input[type='url'] + label:after,
  & input[type='time'] + label:after,
  & input[type='date'] + label:after,
  & input[type='datetime-local'] + label:after,
  & input[type='tel'] + label:after,
  & input[type='number'] + label:after,
  & input[type='search-md'] + label:after,
  & input[type='search'] + label:after,
  & textarea.md-textarea + label:after {
    content: '';
    position: absolute;
    top: 65px;
    display: block;
    opacity: 0;
    transition: 0.2s opacity ease-out, 0.2s color ease-out;
  }
  & input[type='text'].valid,
  & input[type='text']:focus.valid,
  & input[type='password'].valid,
  & input[type='password']:focus.valid,
  & input[type='email'].valid,
  & input[type='email']:focus.valid,
  & input[type='url'].valid,
  & input[type='url']:focus.valid,
  & input[type='time'].valid,
  & input[type='time']:focus.valid,
  & input[type='date'].valid,
  & input[type='date']:focus.valid,
  & input[type='datetime-local'].valid,
  & input[type='datetime-local']:focus.valid,
  & input[type='tel'].valid,
  & input[type='tel']:focus.valid,
  & input[type='number'].valid,
  & input[type='number']:focus.valid,
  & input[type='search-md'].valid,
  & input[type='search-md']:focus.valid,
  & input[type='search'].valid,
  & input[type='search']:focus.valid,
  & textarea.md-textarea.valid,
  & textarea.md-textarea:focus.valid {
    border-bottom: 1px solid #00c851;
    box-shadow: 0 1px 0 0 #00c851;
  }
  & input[type='text'].valid + label:after,
  & input[type='text']:focus.valid + label:after,
  & input[type='password'].valid + label:after,
  & input[type='password']:focus.valid + label:after,
  & input[type='email'].valid + label:after,
  & input[type='email']:focus.valid + label:after,
  & input[type='url'].valid + label:after,
  & input[type='url']:focus.valid + label:after,
  & input[type='time'].valid + label:after,
  & input[type='time']:focus.valid + label:after,
  & input[type='date'].valid + label:after,
  & input[type='date']:focus.valid + label:after,
  & input[type='datetime-local'].valid + label:after,
  & input[type='datetime-local']:focus.valid + label:after,
  & input[type='tel'].valid + label:after,
  & input[type='tel']:focus.valid + label:after,
  & input[type='number'].valid + label:after,
  & input[type='number']:focus.valid + label:after,
  & input[type='search-md'].valid + label:after,
  & input[type='search-md']:focus.valid + label:after,
  & input[type='search'].valid + label:after,
  & input[type='search']:focus.valid + label:after,
  & textarea.md-textarea.valid + label:after,
  & textarea.md-textarea:focus.valid + label:after {
    content: attr(data-success);
    color: #00c851;
    opacity: 1;
  }
  & input[type='text'].invalid,
  & input[type='text']:focus.invalid,
  & input[type='password'].invalid,
  & input[type='password']:focus.invalid,
  & input[type='email'].invalid,
  & input[type='email']:focus.invalid,
  & input[type='url'].invalid,
  & input[type='url']:focus.invalid,
  & input[type='time'].invalid,
  & input[type='time']:focus.invalid,
  & input[type='date'].invalid,
  & input[type='date']:focus.invalid,
  & input[type='datetime-local'].invalid,
  & input[type='datetime-local']:focus.invalid,
  & input[type='tel'].invalid,
  & input[type='tel']:focus.invalid,
  & input[type='number'].invalid,
  & input[type='number']:focus.invalid,
  & input[type='search-md'].invalid,
  & input[type='search-md']:focus.invalid,
  & input[type='search'].invalid,
  & input[type='search']:focus.invalid,
  & textarea.md-textarea.invalid,
  & textarea.md-textarea:focus.invalid {
    border-bottom: 1px solid #f44336;
    box-shadow: 0 1px 0 0 #f44336;
  }
  & input[type='text'].invalid + label:after,
  & input[type='text']:focus.invalid + label:after,
  & input[type='password'].invalid + label:after,
  & input[type='password']:focus.invalid + label:after,
  & input[type='email'].invalid + label:after,
  & input[type='email']:focus.invalid + label:after,
  & input[type='url'].invalid + label:after,
  & input[type='url']:focus.invalid + label:after,
  & input[type='time'].invalid + label:after,
  & input[type='time']:focus.invalid + label:after,
  & input[type='date'].invalid + label:after,
  & input[type='date']:focus.invalid + label:after,
  & input[type='datetime-local'].invalid + label:after,
  & input[type='datetime-local']:focus.invalid + label:after,
  & input[type='tel'].invalid + label:after,
  & input[type='tel']:focus.invalid + label:after,
  & input[type='number'].invalid + label:after,
  & input[type='number']:focus.invalid + label:after,
  & input[type='search-md'].invalid + label:after,
  & input[type='search-md']:focus.invalid + label:after,
  & input[type='search'].invalid + label:after,
  & input[type='search']:focus.invalid + label:after,
  & textarea.md-textarea.invalid + label:after,
  & textarea.md-textarea:focus.invalid + label:after {
    content: attr(data-error);
    color: #f44336;
    opacity: 1;
  }
  & input[type='text'].form-control.valid + label:after,
  & input[type='text'].form-control:focus.valid + label:after,
  & input[type='password'].form-control.valid + label:after,
  & input[type='password'].form-control:focus.valid + label:after,
  & input[type='email'].form-control.valid + label:after,
  & input[type='email'].form-control:focus.valid + label:after,
  & input[type='url'].form-control.valid + label:after,
  & input[type='url'].form-control:focus.valid + label:after,
  & input[type='time'].form-control.valid + label:after,
  & input[type='time'].form-control:focus.valid + label:after,
  & input[type='date'].form-control.valid + label:after,
  & input[type='date'].form-control:focus.valid + label:after,
  & input[type='datetime-local'].form-control.valid + label:after,
  & input[type='datetime-local'].form-control:focus.valid + label:after,
  & input[type='tel'].form-control.valid + label:after,
  & input[type='tel'].form-control:focus.valid + label:after,
  & input[type='number'].form-control.valid + label:after,
  & input[type='number'].form-control:focus.valid + label:after,
  & input[type='search-md'].form-control.valid + label:after,
  & input[type='search-md'].form-control:focus.valid + label:after,
  & input[type='search'].form-control.valid + label:after,
  & input[type='search'].form-control:focus.valid + label:after,
  & textarea.md-textarea.form-control.valid + label:after,
  & textarea.md-textarea.form-control:focus.valid + label:after {
    top: 3.56rem;
  }
  & input[type='text'].form-control.invalid + label:after,
  & input[type='text'].form-control:focus.invalid + label:after,
  & input[type='password'].form-control.invalid + label:after,
  & input[type='password'].form-control:focus.invalid + label:after,
  & input[type='email'].form-control.invalid + label:after,
  & input[type='email'].form-control:focus.invalid + label:after,
  & input[type='url'].form-control.invalid + label:after,
  & input[type='url'].form-control:focus.invalid + label:after,
  & input[type='time'].form-control.invalid + label:after,
  & input[type='time'].form-control:focus.invalid + label:after,
  & input[type='date'].form-control.invalid + label:after,
  & input[type='date'].form-control:focus.invalid + label:after,
  & input[type='datetime-local'].form-control.invalid + label:after,
  & input[type='datetime-local'].form-control:focus.invalid + label:after,
  & input[type='tel'].form-control.invalid + label:after,
  & input[type='tel'].form-control:focus.invalid + label:after,
  & input[type='number'].form-control.invalid + label:after,
  & input[type='number'].form-control:focus.invalid + label:after,
  & input[type='search-md'].form-control.invalid + label:after,
  & input[type='search-md'].form-control:focus.invalid + label:after,
  & input[type='search'].form-control.invalid + label:after,
  & input[type='search'].form-control:focus.invalid + label:after,
  & textarea.md-textarea.form-control.invalid + label:after,
  & textarea.md-textarea.form-control:focus.invalid + label:after {
    top: 3.44rem;
  }
  & input[type='text'].form-control-lg.valid + label:after,
  & input[type='text'].form-control-lg:focus.valid + label:after,
  & input[type='password'].form-control-lg.valid + label:after,
  & input[type='password'].form-control-lg:focus.valid + label:after,
  & input[type='email'].form-control-lg.valid + label:after,
  & input[type='email'].form-control-lg:focus.valid + label:after,
  & input[type='url'].form-control-lg.valid + label:after,
  & input[type='url'].form-control-lg:focus.valid + label:after,
  & input[type='time'].form-control-lg.valid + label:after,
  & input[type='time'].form-control-lg:focus.valid + label:after,
  & input[type='date'].form-control-lg.valid + label:after,
  & input[type='date'].form-control-lg:focus.valid + label:after,
  & input[type='datetime-local'].form-control-lg.valid + label:after,
  & input[type='datetime-local'].form-control-lg:focus.valid + label:after,
  & input[type='tel'].form-control-lg.valid + label:after,
  & input[type='tel'].form-control-lg:focus.valid + label:after,
  & input[type='number'].form-control-lg.valid + label:after,
  & input[type='number'].form-control-lg:focus.valid + label:after,
  & input[type='search-md'].form-control-lg.valid + label:after,
  & input[type='search-md'].form-control-lg:focus.valid + label:after,
  & input[type='search'].form-control-lg.valid + label:after,
  & input[type='search'].form-control-lg:focus.valid + label:after,
  & textarea.md-textarea.form-control-lg.valid + label:after,
  & textarea.md-textarea.form-control-lg:focus.valid + label:after {
    top: 4.1rem;
  }
  & input[type='text'].form-control-lg.invalid + label:after,
  & input[type='text'].form-control-lg:focus.invalid + label:after,
  & input[type='password'].form-control-lg.invalid + label:after,
  & input[type='password'].form-control-lg:focus.invalid + label:after,
  & input[type='email'].form-control-lg.invalid + label:after,
  & input[type='email'].form-control-lg:focus.invalid + label:after,
  & input[type='url'].form-control-lg.invalid + label:after,
  & input[type='url'].form-control-lg:focus.invalid + label:after,
  & input[type='time'].form-control-lg.invalid + label:after,
  & input[type='time'].form-control-lg:focus.invalid + label:after,
  & input[type='date'].form-control-lg.invalid + label:after,
  & input[type='date'].form-control-lg:focus.invalid + label:after,
  & input[type='datetime-local'].form-control-lg.invalid + label:after,
  & input[type='datetime-local'].form-control-lg:focus.invalid + label:after,
  & input[type='tel'].form-control-lg.invalid + label:after,
  & input[type='tel'].form-control-lg:focus.invalid + label:after,
  & input[type='number'].form-control-lg.invalid + label:after,
  & input[type='number'].form-control-lg:focus.invalid + label:after,
  & input[type='search-md'].form-control-lg.invalid + label:after,
  & input[type='search-md'].form-control-lg:focus.invalid + label:after,
  & input[type='search'].form-control-lg.invalid + label:after,
  & input[type='search'].form-control-lg:focus.invalid + label:after,
  & textarea.md-textarea.form-control-lg.invalid + label:after,
  & textarea.md-textarea.form-control-lg:focus.invalid + label:after {
    top: 4rem;
  }
  & input[type='text'].form-control-sm.valid + label:after,
  & input[type='text'].form-control-sm:focus.valid + label:after,
  & input[type='password'].form-control-sm.valid + label:after,
  & input[type='password'].form-control-sm:focus.valid + label:after,
  & input[type='email'].form-control-sm.valid + label:after,
  & input[type='email'].form-control-sm:focus.valid + label:after,
  & input[type='url'].form-control-sm.valid + label:after,
  & input[type='url'].form-control-sm:focus.valid + label:after,
  & input[type='time'].form-control-sm.valid + label:after,
  & input[type='time'].form-control-sm:focus.valid + label:after,
  & input[type='date'].form-control-sm.valid + label:after,
  & input[type='date'].form-control-sm:focus.valid + label:after,
  & input[type='datetime-local'].form-control-sm.valid + label:after,
  & input[type='datetime-local'].form-control-sm:focus.valid + label:after,
  & input[type='tel'].form-control-sm.valid + label:after,
  & input[type='tel'].form-control-sm:focus.valid + label:after,
  & input[type='number'].form-control-sm.valid + label:after,
  & input[type='number'].form-control-sm:focus.valid + label:after,
  & input[type='search-md'].form-control-sm.valid + label:after,
  & input[type='search-md'].form-control-sm:focus.valid + label:after,
  & input[type='search'].form-control-sm.valid + label:after,
  & input[type='search'].form-control-sm:focus.valid + label:after,
  & textarea.md-textarea.form-control-sm.valid + label:after,
  & textarea.md-textarea.form-control-sm:focus.valid + label:after {
    top: 3.2rem;
  }
  & input[type='text'].form-control-sm.invalid + label:after,
  & input[type='text'].form-control-sm:focus.invalid + label:after,
  & input[type='password'].form-control-sm.invalid + label:after,
  & input[type='password'].form-control-sm:focus.invalid + label:after,
  & input[type='email'].form-control-sm.invalid + label:after,
  & input[type='email'].form-control-sm:focus.invalid + label:after,
  & input[type='url'].form-control-sm.invalid + label:after,
  & input[type='url'].form-control-sm:focus.invalid + label:after,
  & input[type='time'].form-control-sm.invalid + label:after,
  & input[type='time'].form-control-sm:focus.invalid + label:after,
  & input[type='date'].form-control-sm.invalid + label:after,
  & input[type='date'].form-control-sm:focus.invalid + label:after,
  & input[type='datetime-local'].form-control-sm.invalid + label:after,
  & input[type='datetime-local'].form-control-sm:focus.invalid + label:after,
  & input[type='tel'].form-control-sm.invalid + label:after,
  & input[type='tel'].form-control-sm:focus.invalid + label:after,
  & input[type='number'].form-control-sm.invalid + label:after,
  & input[type='number'].form-control-sm:focus.invalid + label:after,
  & input[type='search-md'].form-control-sm.invalid + label:after,
  & input[type='search-md'].form-control-sm:focus.invalid + label:after,
  & input[type='search'].form-control-sm.invalid + label:after,
  & input[type='search'].form-control-sm:focus.invalid + label:after,
  & textarea.md-textarea.form-control-sm.invalid + label:after,
  & textarea.md-textarea.form-control-sm:focus.invalid + label:after {
    top: 3.1rem;
  }
  & .was-validated input[type='text']:valid + label {
    color: #00c851 !important;
  }
  & .was-validated input[type='text']:invalid + label {
    color: #f44336 !important;
  }
  & .was-validated .form-control:valid:focus {
    box-shadow: 0 1px 0 0 #00c851 !important;
  }
  & .was-validated .form-control:valid {
    border-color: #00c851 !important;
  }
  & .was-validated .form-control:invalid:focus {
    box-shadow: 0 1px 0 0 #f44336 !important;
  }
  & .was-validated .form-control:invalid {
    border-color: #f44336 !important;
  }
  & .form-control {
    margin: 0 0 0.5rem 0;
    border-radius: 0;
    padding: 0.3rem 0 0.55rem 0;
    background-image: none;
    background-color: transparent;
  }
  & .form-control:focus {
    box-shadow: none;
    background: transparent;
  }
  & .form-control:disabled,
  & .form-control[readonly] {
    border-bottom: 1px solid #bdbdbd;
    background-color: transparent;
  }
  & .validate {
    margin-bottom: 2.5rem;
  }
  & label {
    font-size: 1rem;
  }
  & label.active {
    font-size: 0.8rem;
  }
  & .prefix {
    top: 0.25rem;
    font-size: 1.75rem;
  }
  & .prefix ~ input,
  & .prefix ~ textarea {
    margin-left: 2.5rem;
    width: calc(100% - 2.5rem);
  }
  & .prefix ~ label {
    margin-left: 2.5rem;
  }
  & .prefix ~ .form-text {
    margin-left: 2.6rem;
  }
  & label {
    position: absolute;
    top: 0.65rem;
    left: 0;
    transition: 0.2s ease-out;
    cursor: text;
    color: #757575;
  }
  & label.active {
    transform: translateY(-140%);
  }
  & .prefix {
    position: absolute;
    transition: color 0.2s;
  }
  & .prefix.active {
    color: #4285f4;
  }
  &.form-lg .validate {
    margin-bottom: 2.8rem;
  }
  &.form-lg label {
    font-size: 1.25rem;
  }
  &.form-lg label.active {
    font-size: 0.95rem;
  }
  &.form-lg .prefix {
    top: 0.4rem;
    font-size: 2rem;
  }
  &.form-lg .prefix ~ input,
  &.form-lg .prefix ~ textarea {
    margin-left: 3rem;
    width: calc(100% - 3rem);
  }
  &.form-lg .prefix ~ label {
    margin-left: 3rem;
  }
  &.form-lg .prefix ~ .form-text {
    margin-left: 3.1rem;
  }
  &.form-sm .validate {
    margin-bottom: 2.3rem;
  }
  &.form-sm label {
    font-size: 0.875rem;
  }
  &.form-sm label.active {
    font-size: 0.75rem;
  }
  &.form-sm .prefix {
    top: 0.35rem;
    font-size: 1.5rem;
  }
  &.form-sm .prefix ~ input,
  &.form-sm .prefix ~ textarea {
    margin-left: 2rem;
    width: calc(100% - 2rem);
  }
  &.form-sm .prefix ~ label {
    margin-left: 2rem;
  }
  &.form-sm .prefix ~ .form-text {
    margin-left: 2rem;
  }
  & textarea.md-textarea {
    overflow-y: hidden;
    padding: 1.5rem 0;
    resize: none;
  }
  & textarea.md-textarea-auto {
    padding: 0;
    padding-top: 1.5rem;
  }

  & .input-group label {
    top: 0;
    margin-bottom: 0;
  }

  & .input-group .input-group-text {
    background-color: #e0e0e0;
  }
  & .input-group .input-group-text.md-addon {
    border: none;
    background-color: transparent;
    font-weight: 500;
  }

  & .input-group .form-control {
    margin: 0;
    padding: 0.375rem 0.75rem;
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/md-form.css.js